// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const config = require('../assets/config/config-test.json');

export const environment = {
  production: config.production,
  version: '2.3.3T',
  restBaseUrl: config.apiBaseUrl,
  restBaseUrlWA: config.apiBaseUrlWA,
  restBaseUrlDL: config.apiBaseUrlDL,
  restBaseUrlQBS: config.apiBaseUrlQBS,
  rows: 10,
  defaultTolerance: '3600', // minuti in 24H valore per TEST
  defaultTimerange: '3600',
  idTicketChannel: '6',
  defaultButton: 'stop',
  defaultAR: false,
  defaultViewTrip: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
